import { getGlobalTenant } from "../services/globalTenant";
import regionService from "../services/region";
/**
 * @description: Helper function to get region.
 * This will always request globalTenant but will resolve instantly if we have a locally stored region first.
 */
export default function getRegion(subdomain) {
    var load = getGlobalTenant(subdomain).then(function (tenant) {
        regionService.set(tenant.region);
        regionService.setGlobalTenant(tenant);
    });
    var region = regionService.get();
    if (region) {
        return Promise.resolve();
    }
    return load;
}
